const POPUP_FEATURES =
  'popup=yes,width=520,height=720,menubar=no,toolbar=no,location=no,status=no,resizable=yes,scrollbars=yes';

const POPUP_BLOCKED_MESSAGE = 'Popup blocked. Allow popups for this site and try again.';

function assertPopupOpened(popup: Window | null): asserts popup is Window {
  if (!popup) {
    throw new Error(POPUP_BLOCKED_MESSAGE);
  }
}

/** Open the OIDC popup synchronously during a user gesture (before any await). */
export function openOidcPopupBlank(): Window {
  const popup = window.open('about:blank', 'nice_oidc_login', POPUP_FEATURES);
  assertPopupOpened(popup);

  try {
    popup.document.title = 'NICE Sign In';
    popup.document.body.innerHTML =
      '<p style="font-family:sans-serif;padding:1rem;">Opening NICE sign-in…</p>';
  } catch {
    // Ignore if the popup document is not writable.
  }

  return popup;
}

export function navigateOidcPopup(popup: Window, authorizeUrl: string): void {
  try {
    popup.location.href = authorizeUrl;
  } catch {
    popup.close();
    throw new Error(POPUP_BLOCKED_MESSAGE);
  }
}

export function openOidcPopup(authorizeUrl: string): Window {
  const popup = openOidcPopupBlank();
  navigateOidcPopup(popup, authorizeUrl);
  return popup;
}
